<script>
    import { onMount } from "svelte";


    let language = 'en';
    let scroll = 0;

    /* onMount(() => {
		const page = document.getElementById('page-wrap');
		page.addEventListener('scroll', () => {
			scroll = page.scrollTop;
		});
	}); */
</script>

<div class="about-component-wrapper bg-c" id="about">
    <div class="page-image {(scroll >= window.innerHeight)? '':'height-zero'}"></div>
    <div class="page-content">
        <div class="container">
            <h1 class="font-VarelaRound d-flex justify-content-between">
                about me
                <div>
                    <button
                        class="btn {(language === 'en')? 'btn-primary':'btn-secondary'} btn-sm mx-1"
                        type="button"
                        on:click={() => language = 'en'}>
                        en
                    </button>
                    <button
                        class="btn {(language === 'cn')? 'btn-primary':'btn-secondary'} btn-sm"
                        type="button"
                        on:click={() => language = 'cn'}>
                        cn
                    </button>
                </div>
            </h1>

            {#if language == 'en'}
            <p>
                Nicole Wang, born in Shenyang, China, studied art at the Lu Xun Academy of Fine Arts in Shenyang, China, and later migrated to Singapore with her family. She studied at the NAFA Academy of Fine Arts in Singapore.
            </p>
            <p>
                Now a Singaporean citizen as a professional artist, she is proficient in sketching, watercolor, posters, paintings, etc.. Over the years, Nicole have been persistent in her search for her own language through her creations. The active cum passive involvement of her works have been her long-cherished wish for art to enter life; it's her life journey.
            </p>
            <p>
                Nicole's works are cherished by collectors from the United Kingdom, Taiwan, Singapore, and China.
            </p>

            <div class="row g-2">
                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2022</h5>
                            <p class="card-text">
                                Federation of Art Societies 31th Anniversary
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2022</h5>
                            <p class="card-text">
                                Asia Pacific International Arts Festival
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-primary">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                St. Joseph's institution foundation Singapore
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-info">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                NAFA Ngee Ann Kongsi Gallery Singapore
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-warning">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                The Revenge of the Bat” operetta which is produced as part of NAFA's 80th anniversary celebrations.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                NAFA Campus Singapore
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if language == 'cn'}
            <p>
                王思淳（Nicole Wang)，出生于中国沈阳，幼年于中国沈阳鲁迅美术学院学习美术，后随家人移民生活于新加坡，深造于新加坡NAFA 美术学院学习油画专业。精通素描，水彩，宣传画，油画等。现为新加坡公民是一名职业艺术工作者。多年來，一直堅持並樂此不疲的在創作中尋找我要的語言，主動性與被動性的介入作品，让艺术走进生活一直是其夙愿，多年來從不停歇
            </p>
            <p>
                作品被英國、台灣、新加坡，中國等收藏家收藏。
            </p>

            <div class="row g-2">
                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2022</h5>
                            <p class="card-text">
                                新加坡美术总会 31 周年
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2022</h5>
                            <p class="card-text">
                                亚太国际艺术节
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-primary">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                ST.约瑟夫机构私人拍卖会 新加坡
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-info">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                NAFA Ngee Ann Kongsi 画廊新加坡
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-warning">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                “蝙蝠的复仇”轻歌剧是作为NAFA 80周年庆典的一部分而展出作品。
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card text-bg-success">
                        <div class="card-body">
                            <h5 class="card-title">2018</h5>
                            <p class="card-text">
                                NAFA Campus新加坡
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/if}
        </div>
    </div>
</div>

<style lang="scss">
	@import "src/scss/about";

    .bg-c {
        background: $gray-300;
    }
</style>